module.exports = __webpack_public_path__ + "img/1792492708960.e678e961.png";